import { render, staticRenderFns } from "./NavigationDrawer.vue?vue&type=template&id=640a16e6&scoped=true&"
import script from "./NavigationDrawer.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./NavigationDrawer.vue?vue&type=style&index=0&id=640a16e6&prod&scoped=true&lang=css&"
import style1 from "./NavigationDrawer.vue?vue&type=style&index=1&id=640a16e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a16e6",
  null
  
)

export default component.exports